import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchDepartamentos, useUpdateDepartamento} from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { Departamento } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';

const returnUrlDep = '/parametrizacion/departamentos';

export interface DepartamentosPageInterface {}

const DepartamentosPage: React.FC<DepartamentosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_departamento)
  const navigate = useNavigate();
///* global state
const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
const setConfirmDialogIsOpen = useUiConfirmModalStore(
  s => s.setConfirmDialogIsOpen
);
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: departamentosPagingRes,
    isLoading,
    isRefetching,
  } = useFetchDepartamentos({
    page: pageIndex + 1,
    nombre: searchTerm,
  });
  const upateDepartamentos = useUpdateDepartamento({
    navigate,
    returnUrl:returnUrlDep,
  }
  )

  ///* handlers
  const onEdit = (original: Departamento) => {
    navigate(`${returnUrlDep}/editar/${original.id_departamento}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<Departamento>[]>(
    () => [
      /* {
        accessorKey: 'codigo',
        header: 'codigo',
        size: 90,
      }, */
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'area_data.nombre',
        header: 'Area',
        size: 300,
      },
      
      {
        accessorKey: 'empresa_data.razon_social',
        header: 'empresa',
        size: 300,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={dep => {
              if (!hasPermission(PermissionsEnum.api_change_departamento)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  upateDepartamentos.mutate({
                    id: row.original.id_departamento!,
                    data: {
                      ...row.original,
                      estado: dep as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Departamentos" urlRedirect={`${returnUrlDep}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_departamento)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="departamentos" cleanFilter={cleanFilter} />

      <GeneralTable<Departamento>
        columns={columns}
        data={departamentosPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={departamentosPagingRes?.data?.count}
        // // actions
          enableColumnActions={hasAllPermissions([
            PermissionsEnum.api_change_departamento,
          ])}
        // crud
        onEdit={onEdit}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_departamento,
        ])}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default DepartamentosPage;
